import { Component, forwardRef } from '@angular/core';
import { AdminTableCell } from '../admin-table-cell';

@Component({
  selector: 'mpro-atable-cell',
  template: '<ng-template><ng-content></ng-content></ng-template>',
  providers: [{ provide: AdminTableCell, useExisting: forwardRef(() => AdminTableCellComponent) }]
})
export class AdminTableCellComponent extends AdminTableCell { }